export const API_BASE_URL = 'https://urbrace.com.br/api';
export const CLIENT_ID_GOOGLE = '602292487128-1o5v56gu35i2ofg3l7pl1j5bnoos14nd.apps.googleusercontent.com';
export const MERCADOPAGO_PUBLIC_KEY =  'APP_USR-a568e2ac-b10e-429a-8c0b-d8fde66743f2';
